var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg010SgManageCarriers = function Svg010SgManageCarriers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 379.5v-180c0-55.229 44.772-100 100-100h-60c-55.228 0-100 44.771-100 100v180c0 55.228 44.772 100 100 100h60c-55.228 0-100-44.772-100-100z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296 99.5h96c55.228 0 100 44.772 100 100v180c0 55.228-44.772 100-100 100H120c-55.228 0-100-44.772-100-100v-180c0-55.228 44.772-100 100-100h96V73.29c0-22.429 18.355-41.211 40.78-40.783C278.511 32.923 296 50.669 296 72.5v27zm-80-17v27c0 22.091 17.909 40 40 40s40-17.909 40-40v-27m-1 133h118m-118 81h118m-68 80h68",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 236.5c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.908 40 40zm30 163h0c0-35.164-28.684-64-64.068-64h-11.865c-35.384 0-64.068 28.836-64.068 64v0",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }));
};

export default Svg010SgManageCarriers;